import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProductList from "./product-list";
import AddProduct from "./add-product";
import EditProduct from "./edit-product";
import Stock from "./stock";
import ProtectedRoute from "../../../components/util-components/ProtectedRoute";
import Forecast from "./forecast";
import PriceLists from "./price-lists";
import ReconciliationLog from "./reconciliation";
import ReconciliationDetail from "./reconciliation/detail";

const PARENT_URL = "/cms/products";

const Products = () => {
  return (
    <Routes>
      <Route
        path={`/add-product`}
        element={
          <ProtectedRoute routeKey={"shop-products-addProduct"}>
            <AddProduct />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/edit-product/:id`}
        element={
          <ProtectedRoute routeKey={"shop-products-editProduct"}>
            <EditProduct />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/product-list`}
        element={
          <ProtectedRoute routeKey={"shop-products-productList"}>
            <ProductList />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/stock`}
        element={
          <ProtectedRoute routeKey={"shop-products-stock"}>
            <Stock />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/forecast`}
        element={
          <ProtectedRoute routeKey={"shop-products-forecast"}>
            <Forecast />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/price-lists`}
        element={
          <ProtectedRoute routeKey={"shop-products-price-lists"}>
            <PriceLists />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/reconciliation`}
        element={
          <ProtectedRoute routeKey={"shop-products-reconciliation"}>
            <ReconciliationLog />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/reconciliation/detail/:runId`}
        element={
          <ProtectedRoute routeKey={"shop-products-reconciliation"}>
            <ReconciliationDetail />
          </ProtectedRoute>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/product-list`} replace />} />
    </Routes>
  );
};

export default Products;
